(function () {
  "use strict";

  /* ---- Lightweight, no-backend wishlist. Stores product handles in
     localStorage. Works anywhere in the theme: product cards, header
     badge, and the dedicated wishlist page all read/write the same
     store and stay in sync via the "wishlist:change" custom event. ---- */

  var STORAGE_KEY = "trulvl:wishlist";

  function getAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function save(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* localStorage unavailable (private mode, quota, etc.) — fail silent */
    }
  }

  function has(handle) {
    return getAll().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var handles = getAll();
    var idx = handles.indexOf(handle);
    var added;
    if (idx === -1) {
      handles.push(handle);
      added = true;
    } else {
      handles.splice(idx, 1);
      added = false;
    }
    save(handles);
    document.dispatchEvent(
      new CustomEvent("wishlist:change", {
        detail: { handle: handle, added: added, handles: handles },
      })
    );
    return added;
  }

  function updateBadge() {
    var count = getAll().length;
    document.querySelectorAll("[data-wishlist-count]").forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function syncButtonStates() {
    document.querySelectorAll("[data-wishlist-toggle]").forEach(function (btn) {
      var handle = btn.getAttribute("data-product-handle");
      var saved = has(handle);
      btn.classList.toggle("is-active", saved);
      btn.setAttribute("aria-pressed", saved ? "true" : "false");
    });
  }

  /* ---- Delegate clicks so this works for buttons added dynamically
     (e.g. rendered by the wishlist page itself). ---- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-wishlist-toggle]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute("data-product-handle");
    if (!handle) return;
    toggle(handle);
    syncButtonStates();
  });

  document.addEventListener("wishlist:change", function () {
    updateBadge();
    renderWishlistPage();
  });

  /* ---- Dedicated wishlist page rendering. Fetches each saved product's
     public JSON via Shopify's per-product AJAX endpoint — no app or
     backend required. No-ops on any page without the wishlist grid. ---- */
  function renderWishlistPage() {
    var grid = document.querySelector("[data-wishlist-grid]");
    if (!grid) return;

    var emptyEl = document.querySelector("[data-wishlist-empty]");
    var subhead = document.querySelector("[data-wishlist-subhead]");
    var handles = getAll();

    /* Status-line copy comes from the section's own settings, passed down as
       data-* attributes on [data-wishlist-subhead] (see sections/wishlist.liquid).
       These strings used to be hardcoded here, which meant the merchant could
       edit the wishlist heading in the theme editor but not the line directly
       under it -- including the empty state, which is what every visitor sees
       until they save something. Falls back to the previous literals if a
       setting is ever left blank. */
    var copyOne = (subhead && subhead.dataset.countOne) || "1 item saved.";
    var copyMany = (subhead && subhead.dataset.countMany) || "[count] items saved.";

    if (!handles.length) {
      grid.hidden = true;
      grid.innerHTML = "";
      if (emptyEl) emptyEl.hidden = false;
      /* Empty state: the section's own empty message renders below, so the
         status line is cleared rather than duplicating it. */
      if (subhead) subhead.textContent = "";
      return;
    }

    if (subhead) {
      subhead.textContent =
        handles.length === 1
          ? copyOne
          : copyMany.replace(/\[count\]/gi, handles.length);
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch("/products/" + handle + ".js")
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      grid.innerHTML = "";
      var anyValid = false;

      products.forEach(function (product, i) {
        if (!product) return;
        anyValid = true;

        var handle = handles[i];
        var image = product.featured_image || (product.images && product.images[0]) || "";
        var imageSrc = image ? image + (image.indexOf("?") === -1 ? "?width=600" : "&width=600") : "";
        var price = "$" + (product.price / 100).toFixed(2);

        var card = document.createElement("div");
        card.className = "wishlist-page__card";
        card.innerHTML =
          '<a href="' + product.url + '" class="wishlist-page__card-link">' +
          (imageSrc
            ? '<img src="' + imageSrc + '" alt="' + (product.title || "").replace(/"/g, "&quot;") + '" loading="lazy">'
            : "") +
          "<h3>" + (product.title || "") + "</h3>" +
          "<p>" + price + "</p>" +
          "</a>" +
          '<button type="button" class="wishlist-page__remove" data-wishlist-toggle data-product-handle="' +
          handle +
          '" aria-label="Remove from wishlist">Remove</button>';
        grid.appendChild(card);
      });

      grid.hidden = !anyValid;
      if (emptyEl) emptyEl.hidden = anyValid;
      syncButtonStates();
    });
  }

  window.Trulvl = window.Trulvl || {};
  window.Trulvl.wishlist = { getAll: getAll, has: has, toggle: toggle };

  function init() {
    updateBadge();
    syncButtonStates();
    renderWishlistPage();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
